<template>
    <div class="progress progress-bar-vertical">
        <div
            :class="['progress-bar', variant ? `bg-${variant}` : '']"
            role="progressbar"
            :aria-valuenow="value"
            :aria-valuemin="min"
            :aria-valuemax="max"
            :style="{ height: `${ value }%` }"
        >
            <span class="sr-only">{{ value }}%</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VerticalProgressBar',
    props: {
        value: {
            type: Number,
            default: 0,
        },
        min: {
            type: Number,
            default: 0,
        },
        max: {
            type: Number,
            default: 100,
        },
        variant: {
            type: String,
            default: '',
        },
    },
}
</script>

<style lang="scss">
.progress-bar-vertical {
    width: 10px;
    min-height: 100px;
    display: flex;
    align-items: flex-end;
    margin-right: 20px;
    float: left;
    .progress-bar {
        width: 100%;
        height: 0;
        -webkit-transition: height 0.6s ease;
        -o-transition: height 0.6s ease;
        transition: height 0.6s ease;
    }
}
</style>
